import React, { useEffect } from 'react';
import './AccessDeniedToast.css';

const AccessDeniedToast = ({ message, onClose, visible }) => {
  useEffect(() => {
    if (visible && message) {
      const timer = setTimeout(onClose, 5000);
      return () => clearTimeout(timer);
    }
  }, [visible, message, onClose]);

  if (!visible || !message) return null;

  return (
    <div className="access-denied-toast" role="alert">
      <div className="access-denied-toast-inner">
        <div className="access-denied-icon">
          <i className="fas fa-lock"></i>
        </div>
        <div className="access-denied-content">
          <h4 className="access-denied-title">Access Restricted</h4>
          <p className="access-denied-message">{message}</p>
        </div>
        <button 
          className="access-denied-close" 
          onClick={onClose}
          aria-label="Close"
        >
          <i className="fas fa-times"></i>
        </button>
      </div>
      <div className="access-denied-progress"></div>
    </div>
  );
};

export default AccessDeniedToast;
